import React from 'react';
import { AiFillHome } from 'react-icons/ai';
import { BsFillCaretRightFill } from 'react-icons/bs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Outlet, useLocation } from 'react-router';
import { Link } from 'react-router-dom';

// TODO: make this more robust. probably need a different approach here
// since each route would need to use the previous pieces to build its full URL
const Breadcrumb = () => {
  const location = useLocation();
  const pieces = location.pathname
    .split('/')
    .filter((x) => x)
    .map((x) =>
      x
        .split('-')
        // eslint-disable-next-line @typescript-eslint/no-shadow
        .map((x) => `${x[0].toUpperCase()}${x.slice(1)}`)
        .join(' '),
    );

  return (
    <div className="flex items-center mb-4">
      <Link className="inline-block" to="/">
        <AiFillHome />
      </Link>
      {pieces.map((piece, index) => {
        const path = pieces
          .slice(0, index + 1)
          .join('/')
          .replaceAll(' ', '-')
          .toLowerCase();

        return (
          <div key={`breadcrumb-item-${piece.replaceAll(' ', '-')}`} className="flex items-center">
            <BsFillCaretRightFill className="mx-4 text-xs text-gray-400" />
            <Link className="text-sm font-semibold text-gray-800 underline" to={`/${path}`}>
              {piece}
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export const IndexPage = () => (
  <div className="w-full h-full overflow-auto">
    <Breadcrumb />
    <Outlet />
  </div>
);

export default IndexPage;
